import React, { useEffect, useState, useRef, useContext } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { UserContext } from '../../../context/UserContext'
import ErrorMessage from "../../../common/ErrorMessage/ErrorMessage"
import { modalStyles } from './styles'
import Swal from 'sweetalert2';
import StrategyMultiInputDialog from './StrategyModal_Edit_Dialog'
import Grid from '@mui/material/Grid';
import { DropdownActionTypes } from "@mui/base";
import { DatePicker } from '@mui/lab';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { MenuItem, Select } from "@mui/material";
import { BASE_URL } from "../../../baseUrl"



const StrategyViewDialogEdit = ({open, handleClose, id_client, id_strategy, type_request,onSubmitRefresh, size}) => {

    /*Common variables for all the dialogs - types*/ 
    const [login] = useContext(UserContext);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);

    /*variables for canvas view and scatter*/
    const canvasRef = useRef(null);
    const canvasRefEdit = useRef(null);
    const [points, setPoints] = useState([]);
    const [activePoint, setActivePoint] = useState(null);
    const [isCursorActive, setCursorActive] = useState(false);
    const [desc_strategy,setDesc_Strategy] = useState("");
    const [x_axis, setX_Axis] = useState("");
    const [y_axis, setY_Axis] = useState("");
    const [validfrom, setValidFrom] = useState("");
    const [validto, setValidTo] = useState("");
    const [sdggroup, setSdgGroup] = useState("");
    const [access,setAccess] = useState("");
    const currentDate = new Date();
    const formattedCurrentDate = formatDate(currentDate);

    /*variables for update only */
    const [update_desc_strategy, setUpdate_Desc_Strategy] = useState("");
    const [update_x_axis, setUpdate_X_Axis] = useState("");
    const [update_y_axis, setUpdate_Y_Axis] = useState("");
    const [updatevalidfrom, setUpdateValidFrom] = useState("");
    const [updatevalidto, setUpdateValidTo] = useState("");
    const [updatesdggroup, setUpdateSdgGroup] = useState("");
    const [updateaccess, setUpdateAccess] = useState("");
    const [sdgOptions, setSdgOptions] = useState("[]");

    /*variables for multi insert dialog*/
    const [inputDialogOpen, setInputDialogOpen] = useState(false);
    const [currentX,setCurrentX] = useState("")
    const [currentY,setCurrentY] = useState("")

    const cleanFormData = () => {
        setDesc_Strategy("");
        setX_Axis(x_axis);
        setY_Axis(y_axis);
        setValidFrom(formattedCurrentDate);
        setValidTo("2050-01-01");
        setSdgGroup(sdggroup);
    };
      
    const cleanFormDataUpdate = () => {
        setUpdate_X_Axis(x_axis);
        setUpdate_Y_Axis(y_axis);
        setUpdateValidFrom(formattedCurrentDate);
        setUpdateValidTo("2050-01-01");
        setUpdateSdgGroup(sdggroup)
    };

    function formatDate(date) { 
      let day = date.getDate();
      let month = date.getMonth() + 1; // Months start from 0
      let year = date.getFullYear();
      
      // Ensuring two digits for day and month
      day = day < 10 ? '0' + day : day;
      month = month < 10 ? '0' + month : month;
      
      return `${year}-${month}-${day}`;
    }
    
    /*****************************************/
    /*Draw canvas*/
    const drawCanvas = () => {
        const canvas = canvasRef.current;
        if (!canvas) return; // Safety check to ensure canvas is not null
        const ctx = canvas.getContext('2d');
        // Draw axes and points every time the canvas needs to be updated
        drawAxes(ctx);
        points.forEach(point => {
          drawPoint(ctx, point.x, point.y, point.goaltext, point.validfrom, point.validto, point.sdg);
        });
        // Draw the current point from x_axis and y_axis state
        if (x_axis && y_axis) {
          drawPoint(ctx, parseFloat(x_axis), parseFloat(y_axis), desc_strategy);
        }
    };


    const drawAxes = (ctx) => {
        const canvas = canvasRef.current;
        
        ctx.clearRect(0,0,canvas.width, canvas.height);
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(146, 209, 223)';
        ctx.moveTo(canvas.width / 2, 0);
        ctx.lineTo(canvas.width / 2, canvas.height);
        ctx.moveTo(0, canvas.height / 2);
        ctx.lineTo(canvas.width, canvas.height / 2);
        ctx.stroke();
        ctx.fillStyle = 'rgb(146, 209, 223)';
        ctx.fillText('Negative impact', 10, canvas.height / 2 + 12);
        ctx.rotate(Math.PI / -2);
        ctx.fillText('Less Common', -canvas.width + 10, canvas.width / 2 - 8);
        ctx.rotate(Math.PI / 2);
        ctx.fillText('Positive impact', canvas.width - 75, canvas.height / 2 - 8);
        ctx.rotate(Math.PI / -2);
        ctx.fillText(
          'More Common',
          -canvas.width + canvas.width - 75,
          canvas.width / 2 + 12
        );
        ctx.rotate(Math.PI / 2);
    };

    useEffect(() => {
        cleanFormDataUpdate()
        if (open) {
          if (type_request === 3) {
            cleanFormData();
            setPoints([])
          } else {
            fetchStrategyData();
          }
        }
      }, [open, id_client, id_strategy,type_request]);
    
    /**********************************************/
    /*Load the strategy data*/
    const fetchStrategyData = async () => {
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + login.token,
          },
        };
        try {
          const response = await fetch(BASE_URL + `/api/strategy/${id_client}/${id_strategy}`, requestOptions);
          if (!response.ok) {
            throw new Error('Could not get the strategy info');
          }
          const data = await response.json();
          setDesc_Strategy(data.Desc_Strategy);
          setX_Axis(data.X_Axis);
          setY_Axis(data.Y_Axis);
          setValidFrom(data.ValidFrom);
          setValidTo(data.ValidTo);
          setSdgGroup(data.SDG_Group)
          if (type_request === 1) {
            setUpdate_Desc_Strategy(data.Desc_Strategy);
            setUpdateValidFrom(data.ValidFrom);
            setUpdateValidTo(data.ValidTo);
            setUpdateSdgGroup(data.SDG_Group);
            setUpdateAccess(data.Access);
            setAccess(data.Access)

            setPoints((prevPoints) => [
              ...prevPoints,
              { x: data.X_Axis, y: data.Y_Axis, goaltext:data.Desc_Strategy, validfrom:data.ValidFrom, validto: data.ValidTo, sdg: data.SDG_Group, access:data.Access }, // Ensure `currentX` and `currentY` are the coordinates where the canvas was clicked
            ]);

          }
          // Set other state as needed
        } catch (error) {
          setErrorMessage(error.message);
        }
    };

    /**********************************************/
    /*Delete strategy*/
    const handleDelete = async (e,id) => {
        e.stopPropagation();
        console.log("delete process - id:")
        console.log(id)
        const requestOptions = {
          method: "delete",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + login.token,
          },
        };
        const response = await fetch(BASE_URL + `/api/strategy/${id_client}/${id_strategy}`, requestOptions);
        if (!response.ok) {
          setErrorMessage("Failed to delete lead");
        }
        handleClose(); // Close the dialog on canvas click
        onSubmitRefresh(true)
    };

    /**********************************************/
    /*Update strategy data*/

    const handleCanvasMouseDown_Update = (e) => {
      if (points.length < 2) {
        const canvas = canvasRef.current;
        const canvasRect = canvas.getBoundingClientRect();
        const x = e.clientX - canvasRect.left - canvas.width / 2;
        const y = canvas.height / 2 - (e.clientY - canvasRect.top);
        setUpdate_X_Axis(x)
        setUpdate_Y_Axis(y)
      }
    };

    const handleCanvasMouseDown = (e) => {
      const canvas = canvasRef.current;
      const canvasRect = canvas.getBoundingClientRect();
      const x = e.clientX - canvasRect.left - canvas.width / 2;
      const y = canvas.height / 2 - (e.clientY - canvasRect.top);
      console.log("**points start ***")
      console.log(points)
      for (let i = 0; i < points.length; i++) {
        if (
          Math.abs(points[i].x - x) < 5 &&
          Math.abs(points[i].y - y) < 5
        ) {
          setActivePoint(points[i]);
          break;
        }
      }
    };


  

    const handleUpdateStrategy = async () => {

      const updatedXAxis = update_x_axis === '' ? x_axis : update_x_axis;
      const updatedYAxis = update_y_axis === '' ? y_axis : update_y_axis;

      const requestOptions = {
        method: "POST",
        headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + login.token
        },
        body: JSON.stringify({
          Desc_Strategy: update_desc_strategy,
          ValidFrom: updatevalidfrom,
          ValidTo: updatevalidto,
          X_Axis: Math.round(updatedXAxis), 
          Y_Axis: Math.round(updatedYAxis),
          SDG_Group: updatesdggroup,
          Access: updateaccess,
          RootPath: "",
          ID_TimeInterval: 0,
          ID_Leed: 0,
          ID_Envision: 0   
        })
      };

      console.log('values to update')
      console.log(requestOptions.body)
      try {
        const response = await fetch(BASE_URL + `/api/strategy/${id_client}/${id_strategy}`, requestOptions);
        if (!response.ok) {
          throw new Error('Failed to update strategy data');
        }
        // Handle successful update
        
        handleClose(); // Close the dialog
        onSubmitRefresh(true); // Trigger refresh of main view

      } catch (error) {
        setErrorMessage(error.message);
      }
    };
  
    const handleResetUpdate = () => {
      // Reset update_x_axis and update_y_axis to their initial values
      setUpdate_X_Axis(x_axis); 
      setUpdate_Y_Axis(y_axis); 
      //reduce array size
      setPoints((prevPoints) => prevPoints.slice(0, -1));
    };
    
    /**********************************************/
    /*Create new strategy data*/
    const handleCreateStrategy= async (e,strategyPoints) => {
      console.log('**************')
      console.log(strategyPoints)
        e.preventDefault();
        try{
          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + login.token,
            },
          };
      
          const requests = strategyPoints.map((point) => {
            const body = {
              Desc_Strategy: point.goaltext,
              ValidFrom: point.validfrom,
              ValidTo: point.validto,
              X_Axis: Math.round(point.x),
              Y_Axis: Math.round(point.y),
              SDG_Group: point.sdg,
              Access: point.access,
              RootPath: '',
              ID_TimeInterval: 0,
              ID_Leed: 0,
              ID_Envision: 0,
            };
            return fetch(BASE_URL + `/api/strategy/${id_client}`, {
              ...requestOptions,
              body: JSON.stringify(body),
            });
          });

  
          // Show loading animation while requests are being processed
          // Set loading to true before starting the API calls
          setLoading(true);
          await Promise.all(requests);
          setLoading(false);
  
          cleanFormData();
          setInputDialogOpen(false); // Close the dialog on canvas click
          onSubmitRefresh(true)
  
        } catch (error){
          setErrorMessage("Something went wrong when creating strategy");
        }
  
    }

    const drawPoint = (ctx, x, y, goaltext, validfrom = '', validto = '', sdg ='', access=0) => {
      const canvas = canvasRef.current;
      ctx.fillStyle = 'rgb(146, 209, 223)';
      ctx.beginPath();
      ctx.arc(
        x + canvas.width / 2,
        canvas.height / 2 - y,
        5,
        0,
        2 * Math.PI
      );
      ctx.fill();
      ctx.fillText(`${goaltext}`, x + canvas.width / 2 + 10, canvas.height / 2 - y);
      /*just in case to display more than param: `${goaltext} - ${sdg}`*/
    };

    const handleCanvasClick = (e) => {
      const canvas = canvasRef.current;
      const canvasRect = canvas.getBoundingClientRect();
      const x = e.clientX - canvasRect.left - canvas.width / 2;
      const y = canvas.height / 2 - (e.clientY - canvasRect.top);
      setCurrentX(x)
      setCurrentY(y)

        // Only update point if type_request is 1
        if (type_request === 1) {
          setX_Axis(x.toString());
          setY_Axis(y.toString());
      } else {
          setInputDialogOpen(true); // Open the dialog on canvas click
      }
    };

    const handleStrategyInputSubmit = (data) => {
      const { goaltext, validfrom, validto, sdg, access } = data;
      setPoints((prevPoints) => [
        ...prevPoints,
        { x: currentX, y: currentY, goaltext, validfrom, validto, sdg, access }, // Ensure `currentX` and `currentY` are the coordinates where the canvas was clicked
      ]);
    };

    const redraw = (ctx) => {
      const canvas = canvasRef.current;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawAxes(ctx);
      for (let i = 0; i < points.length; i++) {
        const { x, y, goaltext, validfrom, validto, sdg, access } = points[i];
        drawPoint(ctx, x, y, goaltext, validfrom, validto, sdg, access );
      }
      console.log("**points end***")
      console.log(points)
    };


    useEffect(() => {
        if (open && canvasRef.current) {
          drawCanvas();
        }
      }, [x_axis, y_axis, open]); // Redraw canvas when these dependencies change

    useEffect(() => {
      if (type_request === 3 || (type_request === 1 && points.length > 0)) {
        console.log('effect value of points')
        console.log(points)
        if (open && canvasRef.current) {
          const ctx = canvasRef.current.getContext('2d');
          redraw(ctx);
        }
      }
      }, [points, open, type_request]);

    useEffect(()=> {
      if ((update_x_axis !== 0 && update_y_axis !== 0 && update_x_axis !== '' && update_y_axis !== '')){
        console.log('effect value updates')
        console.log(update_x_axis)
        console.log(update_y_axis)
        setPoints((prevPoints) => [
          ...prevPoints,
          { x: update_x_axis, y: update_y_axis, goaltext:update_desc_strategy, validfrom:updatevalidfrom, validto:updatevalidto, sdg:updatesdggroup, access:updateaccess }, // Ensure `currentX` and `currentY` are the coordinates where the canvas was clicked
        ]);
      }
    },[update_x_axis,update_y_axis])


    /**********************************************/

    return (
        <Dialog
            maxWidth={size} fullWidth
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    handleClose();
                }
            }}
            ModalProps={{disableEnforceFocus: true}}
            classes={{ paper: 'custom-dialog' }}
            PaperProps={{ style: { backgroundColor: '#231E39'}}}
        >
          
          {type_request === 0 ?(
            <>
              <DialogTitle style={{color: 'white'}}>Strategy details</DialogTitle>
              <DialogContent style={{color: 'white'}}>
                  <DialogContentText style={{color: 'whitesmoke'}}>
                      {desc_strategy}
                  </DialogContentText>

                  <TextField
                      autoFocus
                      margin="dense"
                      id="x_axis"
                      label="X coordinate"
                      value = {x_axis}
                      type="text"
                      fullWidth
                      variant="standard"
                      InputProps={{
                          readOnly: true,
                      }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'lightgray' },
                        '& .MuiInputLabel-root':  { color: 'gray'}                 
                      }}
                  />

                  <TextField
                      autoFocus
                      margin="dense"
                      id="y_axis"
                      label="Y coordinate"
                      value = {y_axis}
                      type="text"
                      fullWidth
                      variant="standard"
                      InputProps={{
                          readOnly: true,
                      }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'lightgray' },
                        '& .MuiInputLabel-root':  { color: 'gray'}                 
                      }}
                  />

                  <TextField
                      margin="dense"
                      id="validfrom"
                      label="Valid from"
                      value={validfrom} // Make sure this is in 'YYYY-MM-DD' format
                      type="date"
                      fullWidth
                      variant="standard"
                      InputProps={{
                          readOnly: true,
                      }}
                      
                      sx={{
                        
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'lightgray' },
                        '& .MuiInputLabel-root':  { color: 'gray'},
                      }}
                     
                  />

                  <TextField
                      margin="dense"
                      id="validto"
                      label="Valid to"
                      value={validto} // Make sure this is in 'YYYY-MM-DD' format
                      type="date"
                      fullWidth
                      variant="standard"
                      InputProps={{
                          readOnly: true,
                      }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'lightgray' },
                        '& .MuiInputLabel-root':  { color: 'gray'}                 
                      }}
                  />

                  <TextField
                      autoFocus
                      margin="dense"
                      id="sdggroup"
                      label="SDG Group"
                      value = {sdggroup}
                      type="text"
                      fullWidth
                      variant="standard"
                      InputProps={{
                          readOnly: true,
                      }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'lightgray' },
                        '& .MuiInputLabel-root':  { color: 'gray'}                 
                      }}
                  />

                  <section className={modalStyles.container} id="about">

                      {/* Plotting the Canvas for the Scatterplot Edit */}
                          <div className={modalStyles.content}>
                              <canvas
                                  id="scatter"
                                  className="scatter"
                                  ref={canvasRef}
                                  width={500}
                                  height={500}
                              ></canvas>
                          </div>
                  </section> 

              </DialogContent>
              <DialogActions sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}>
                  <Button onClick={handleClose}
                  sx={{
                    paddingRight: '1.5rem',
                    marginRight: '1.5rem',
                    border: '1px solid var(--main-color)',
                    
                  }}
                  >Cancel</Button>
              </DialogActions>
            </>
          ):type_request === 1 ?(
            <>
              <DialogTitle style={{color: 'white'}}>Update Strategy data</DialogTitle>
              <DialogContent style={{color: 'white'}}>
                
                <DialogContentText style={{color: 'lightgray', marginLeft: '5rem', marginRight: '5rem'}}>
                  The existing strategy is plotted in the cartesian plane shown below. You can edit its location by clicking in the the canvas (New X and Y coordinates). You can also edit all other details below.
                </DialogContentText>

                <Grid container spacing={2}>
                  <Grid item xs={3}> 
                    <TextField
                      autoFocus
                      margin="dense"
                      id="description"
                      label="Current Description"
                      value = {desc_strategy}
                      type="text"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        readOnly: true,
                      }}
                          
                      sx={{
                          '& .MuiInput-input': { backgroundColor: '#25274D', color: 'gray', opacity: '50%' },
                            '& .MuiInputLabel-root':  { color: 'gray', opacity: '50%'}                 
                      }}
                    />
                  </Grid>
                  
                  <Grid item xs={9}> 
                    <TextField
                      autoFocus
                      margin="dense"
                      id="update_description"
                      label="New Description"
                      value = {update_desc_strategy}
                      type="text"
                      fullWidth
                      variant="standard"
                      onChange={(e) => setUpdate_Desc_Strategy(e.target.value)}
                          
                      sx={{
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}
                    />
                  </Grid>
                </Grid>
                        
                <Grid container spacing={2}>
                  <Grid item xs={3}> 
                    <TextField
                      autoFocus
                      margin="dense"
                      id="x_axis"
                      label="Current X coordinate"
                      value = {x_axis}
                      type="text"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        readOnly: true,
                      }}
                          
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'gray', opacity: '50%' },
                          '& .MuiInputLabel-root':  { color: 'gray', opacity: '50%'}                 
                    }}
                    />
                  </Grid>
                  
                  <Grid item xs={9}> 
                    <TextField
                      autoFocus
                      margin="dense"
                      id="update_x_axis"
                      label="New X coordinate"
                      placeholder = {x_axis}
                      value={update_x_axis ||  x_axis}
                      type="text"
                      fullWidth
                      variant="standard"
                      onChange={(e) => setUpdate_X_Axis(e.target.value)}
                      InputProps={{
                        readOnly: false,
                      }}
                          
                      sx={{
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}
                    />
                  </Grid>
                </Grid>
                
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="y_axis"
                      label="Current Y coordinate"
                      value = {y_axis}
                      type="text"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        readOnly: true,
                        }}
                        sx={{
                          '& .MuiInput-input': { backgroundColor: '#25274D', color: 'gray', opacity: '50%' },
                            '& .MuiInputLabel-root':  { color: 'gray', opacity: '50%'}                 
                      }}
                    />
                  </Grid>
                  <Grid item xs={9}>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="y_axis"
                      label="New Y coordinate"
                      placeholder = {y_axis}
                      value = {update_y_axis  || y_axis}
                      type="text"
                      fullWidth
                      variant="standard"
                      onChange={(e) => setUpdate_Y_Axis(e.target.value)}
                      InputProps={{
                        readOnly: false,
                        }}
                        sx={{
                          '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                          '& .MuiInputLabel-root': { color: 'white' },
                        }}
                    />
                    </Grid>
                </Grid>
                
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <TextField
                      margin="dense"
                      id="validfrom"
                      label="Current Valid from"
                      value={validfrom} // Make sure this is in 'YYYY-MM-DD' format
                      type="date"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'gray', opacity: '50%' },
                          '& .MuiInputLabel-root':  { color: 'gray', opacity: '50%'}                 
                    }}
                    />
                  </Grid> 
                  
                  <Grid item xs={9}>
                    <TextField
                      margin="dense"
                      id="updatevalidfrom"
                      label="New Valid from"
                      type="date" 
                      value={updatevalidfrom}
                      onChange={(e) => setUpdateValidFrom(e.target.value)}
                      fullWidth
                      variant="standard"
                      InputProps={{readOnly: true,  }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}
                    />
                    
                  </Grid>
                </Grid> 
                
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <TextField
                      margin="dense"
                      id="validto"
                      label="Valid to"
                      value={validto} // Make sure this is in 'YYYY-MM-DD' format
                      type="date"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'gray', opacity: '50%' },
                          '& .MuiInputLabel-root':  { color: 'gray', opacity: '50%'}                 
                    }}
                    />
                  </Grid>
                  
                  <Grid item xs={9}>
                    <TextField
                      margin="dense"
                      id="updatevalidto"
                      label="New Valid to"
                      value={updatevalidto} // Make sure this is in 'YYYY-MM-DD' format
                      type="date"
                      fullWidth
                      variant="standard"
                      onChange={(e) => setUpdateValidTo(e.target.value)}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}
                    />
                  </Grid>
                </Grid>
                
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="sdggroup"
                      label="SDG Group"
                      value = {sdggroup}
                      type="text"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'gray', opacity: '50%' },
                          '& .MuiInputLabel-root':  { color: 'gray', opacity: '50%'}                 
                    }}
                    />
                  </Grid>

                  <Grid item xs={9}>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="updatesdggroup"
                      label="New SDG Group"
                      value = {updatesdggroup}
                      select
                      fullWidth
                      variant="standard"
                      onChange={(e) => setUpdateSdgGroup(e.target.value)}
                      sx={{
                        '& .MuiInputBase-root': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}
                      >
                        <MenuItem value={0}>Unknown</MenuItem>
                        <MenuItem value={1}>SDG1 - No poverty</MenuItem>
                        <MenuItem value={2}>SDG2 - Zero Hunger</MenuItem>
                        <MenuItem value={3}>SDG3 - Good Health and well-being</MenuItem>
                        <MenuItem value={4}>SDG4 - Quality Education</MenuItem>
                        <MenuItem value={5}>SDG5 - Gender Equality</MenuItem>
                        <MenuItem value={6}>SDG6 - Clean Water and Sanitation</MenuItem>
                        <MenuItem value={7}>SDG7 - Affordable and Clean Energy</MenuItem>
                        <MenuItem value={8}>SDG8 - Decent work and Economic Growth</MenuItem>
                        <MenuItem value={9}>SDG9 - Industry, Innovation and infrastructre</MenuItem>
                        <MenuItem value={10}>SDG10 - Reduce Inequalities</MenuItem>
                        <MenuItem value={11}>SDG11 - Sustainable Cities and communities</MenuItem>
                        <MenuItem value={12}>SDG12 - Responsible Consumption and Production</MenuItem>
                        <MenuItem value={13}>SDG13 - Climate Action</MenuItem>
                        <MenuItem value={14}>SDG14 - Life Below Water</MenuItem>
                        <MenuItem value={15}>SDG15 - Line On Land</MenuItem>
                        <MenuItem value={17}>SDG16 - Peace, justice and strong institutions</MenuItem>
                        <MenuItem value={17}>SDG17 - Partnerships for the goals</MenuItem>
                      </TextField>
                   
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="access"
                      label="Access"
                      value = {access}
                      type="text"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{
                        '& .MuiInput-input': { backgroundColor: '#25274D', color: 'gray', opacity: '50%' },
                          '& .MuiInputLabel-root':  { color: 'gray', opacity: '50%'}                 
                    }}
                    />
                  </Grid>

                  <Grid item xs={9}>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="updateaccess"
                      label="New Access Selection"
                      value = {updateaccess}
                      select
                      fullWidth
                      variant="standard"
                      onChange={(e) => setUpdateAccess(e.target.value)}
                      sx={{
                        '& .MuiInputBase-root': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}
                      >
                      <MenuItem value={0}>Public</MenuItem>
                      <MenuItem value={1}>Private</MenuItem>
                    </TextField>
                    
                  </Grid>
                </Grid>

                <section className={modalStyles.container} id="about">

                {/* Plotting the Canvas for the Scatterplot Edit */}
                    <div className={modalStyles.content}>
                        <canvas
                            id="scatter"
                            className="scatter"
                            ref={canvasRef}
                            width={500}
                            height={500}
                            onMouseDown={handleCanvasMouseDown_Update}                 
                        ></canvas>
                    </div>
                </section> 
              
              </DialogContent>

              <DialogActions sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}>
                  
                  <Button 
                    variant="outlined" 
                    onClick={handleResetUpdate}
                    sx={{
                      paddingRight: '1.5rem',
                      marginRight: '1.5rem',
                      border: '1px solid var(--main-color)',
                      color: 'var(--main-color)'
                    }}>
                    Reset New Coordinates
                  </Button>

                  
                  <Button 
                    onClick={() => handleUpdateStrategy(points)}
                    sx={{
                      paddingRight: '1.5rem',
                      marginRight: '1.5rem',
                      border: '1px solid var(--main-color)',
                      
                    }}>
                    Save Changes to Database</Button>
                  

                  <Button onClick={handleClose}
                  sx={{
                    paddingRight: '1.5rem',
                    marginRight: '1.5rem',
                    border: '1px solid var(--main-color)',
                    
                  }}
                  >Cancel</Button>
                  
              </DialogActions>
            </>
          ):type_request === 2 ?(
            <>
              <DialogTitle style={{color: 'white'}}>Delete Strategy - {desc_strategy} </DialogTitle>
              <DialogContentText style={{color: 'lightgray', marginLeft: '5rem', marginRight: '5rem'}}>
                This action will remove the strategy and all the information related, including the documents and progress data. Are you sure you want to continue?
              </DialogContentText>
              <DialogActions sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}>
                  <Button 
                    onClick={(e)=>handleDelete(e, id_strategy)}
                    sx={{
                      paddingRight: '1.5rem',
                      marginRight: '1.5rem',
                      border: '1px solid var(--main-color)',
                      
                    }}
                    >
                    Delete </Button>
                  <Button onClick={handleClose}
                  sx={{
                    paddingRight: '1.5rem',
                    marginRight: '1.5rem',
                    border: '1px solid var(--main-color)',
                    
                  }}
                  >Cancel</Button>
              </DialogActions>
            </>
          ):(
            <>
              <DialogTitle style={{color: 'white'}}>Creating a new strategy / action... </DialogTitle>
              <DialogContentText style={{color: 'lightgray', marginLeft: '5rem', marginRight: '5rem'}}>
                Please click on the canvas where you think your strategy or action in your 2050Commitment is located today.
                There is no right or wrong answer here. Your picked location should be based on your current interpretation of how much IMPACT ("X" axis), and how COMMON ("Y" axis) is your solution / action / strategy today.
                When mapping this, think about your city or community, compared to what you consider peer cities / communities
              </DialogContentText>
              <DialogContent>
  
                  <section className={modalStyles.container} id="about">
                      <canvas
                      id="scatter"
                      className="scatter"
                      ref={canvasRef}
                      width={500}
                      height={500}
                      onClick={handleCanvasClick}
                      onMouseDown={handleCanvasMouseDown}
                    ></canvas>

                  </section> 
                  <StrategyMultiInputDialog open={inputDialogOpen} onClose={() => setInputDialogOpen(false)} onSubmit={handleStrategyInputSubmit} />

              </DialogContent>
              
              <DialogActions
              sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}>
                  
                  <Button 
                    onClick={(e)=>handleCreateStrategy(e, points)}
                    sx={{
                      paddingRight: '1.5rem',
                      marginRight: '1.5rem',
                      border: '1px solid var(--main-color)',
                      
                    }}>
                    Save to Database</Button>

                  <Button onClick={handleClose}
                   sx={{
                        paddingRight: '1.5rem',
                        marginRight: '1.5rem',
                        border: '1px solid var(--main-color)',
                                        
                       }}>Cancel</Button>
              
              </DialogActions>
            </>
          )  
          }
          
        </Dialog>  
    )

}

export default StrategyViewDialogEdit;